import React from "react";

// Paper-grain texture for the flat illustrations. fractalNoise desaturated to
// grey, then multiplied over the artwork so it darkens unevenly the way ink on
// paper does. Ids are namespaced because several illustrations can share a page.
export const GrainDefs = ({ id }) => (
  <filter id={`${id}-grain`} x="0" y="0" width="100%" height="100%">
    <feTurbulence
      type="fractalNoise"
      baseFrequency="0.9"
      numOctaves="3"
      stitchTiles="stitch"
      result="noise"
    />
    <feColorMatrix in="noise" type="saturate" values="0" />
  </filter>
);

// Lay this over the artwork, inside the same clip as the panel.
export const GrainOverlay = ({ id, width, height, rx = 0, opacity = 0.22 }) => (
  <rect
    width={width}
    height={height}
    rx={rx}
    filter={`url(#${id}-grain)`}
    opacity={opacity}
    style={{ mixBlendMode: "multiply" }}
    pointerEvents="none"
  />
);

export default GrainDefs;
